import api from '../utils/api';
import { TicketGroupResponse } from './userService';

export type OrganizerTicket = {
  id: number;
  sequenceNumber: number;
  status: 'valid' | 'redeemed';
  redeemedAt?: string | null;
  orderItemId?: number;
  orderItemQrToken?: string;
  source?: 'primary' | 'related';
};

export type OrganizerRelatedOrder = TicketGroupResponse & {
  validTickets: OrganizerTicket[];
  redeemedTickets: OrganizerTicket[];
};

export type CheckInPayload = TicketGroupResponse & {
  validTickets: OrganizerTicket[];
  redeemedTickets: OrganizerTicket[];
  relatedOrders?: OrganizerRelatedOrder[];
  aggregateValidTickets?: OrganizerTicket[];
  aggregateCounts?: {
    total: number;
    valid: number;
    redeemed: number;
  };
};

export interface ScanResponse {
  state: 'needs_selection' | 'auto_redeemed' | 'already_redeemed';
  payload: CheckInPayload;
  autoRedeemedTicketIds?: number[];
}

export interface RedeemResponse {
  state: 'redeemed' | 'already_redeemed' | 'no_valid_selection';
  payload: CheckInPayload;
  redeemedTicketIds?: number[];
  message?: string;
}

class CheckInService {
  async scan(qrToken: string): Promise<ScanResponse> {
    return await api.post<ScanResponse>('/organizer/check-in/scan', {
      qr_token: qrToken,
    });
  }

  async redeem(qrToken: string, ticketIds: number[], admitAll = false): Promise<RedeemResponse> {
    return await api.post<RedeemResponse>('/organizer/check-in/redeem', {
      qr_token: qrToken,
      ticket_ids: ticketIds,
      admit_all: admitAll,
    });
  }
}

export const checkInService = new CheckInService();
